import { Box, Flex, FormControl } from '@chakra-ui/react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import * as React from 'react';
import { components } from 'react-select';
import DateRangePicker from '~/components/DateRangePicker';
import FormLabel from '~/components/FormLabel/FormLabel';
import Select from '~/components/Select';
import Toggle from '~/components/Toggle';

import { RecentContentFiltersBarTagSelect } from './components';
import { datePickerControllerProps, datePickerProps } from './utils';

const propTypes = {
  sortByValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onSortByChange: PropTypes.func.isRequired,
  sortingOptions: PropTypes.array,
  adFilterValue: PropTypes.bool,
  onAdFilterChange: PropTypes.func,
  tagsValue: PropTypes.arrayOf(PropTypes.string),
  onTagsChange: PropTypes.func,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onDatesChange: PropTypes.func.isRequired,
};
/* eslint-disable react/prop-types */
const SingleValue = ({ data, ...props }) => {
  const { label } = data;

  return (
    <components.SingleValue
      {...props}
    >{`Sort by ${label}`}</components.SingleValue>
  );
};
/* eslint-enable react/prop-types */

const DesktopFiltersBar = ({
  sortByValue,
  onSortByChange,
  sortingOptions,
  adFilterValue,
  onAdFilterChange,
  tagsValue,
  onTagsChange,
  startDate,
  endDate,
  onDatesChange,
}) => {
  const handleToggle = () => {
    onAdFilterChange(!adFilterValue);
  };

  return (
    <Flex align="flex-start" marginBottom="3" wrap="wrap" width="100%">
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onDatesChange={onDatesChange}
        controllerProps={{
          ...datePickerControllerProps,
          // so current month is on right
          initialVisibleMonth: () => dayjs().subtract(1, 'month'),
        }}
        marginRight="auto"
        marginBottom="2"
        {...datePickerProps}
      />

      {onAdFilterChange && (
        <FormControl
          align="center"
          display="flex"
          flexDirection={{ sm: 'row-reverse', lg: 'row' }}
          marginLeft="auto"
          marginRight={{ sm: 2, lg: 6 }}
          marginY="2"
          width="auto"
        >
          <Toggle
            id="ad-toggle-desktop"
            isChecked={adFilterValue}
            marginRight={2}
            onChange={handleToggle}
          />
          <FormLabel
            color="gray.800"
            fontSize="md"
            htmlFor="ad-toggle-desktop"
            marginRight={1}
            padding={0}
            verticalAlign="baseline"
          >
            Includes #ad
          </FormLabel>
        </FormControl>
      )}

      {onTagsChange && (
        <RecentContentFiltersBarTagSelect
          marginBottom={2}
          marginRight={{ sm: 2, lg: 4 }}
          onChange={onTagsChange}
          tags={tagsValue}
          width="250px"
        />
      )}
      <Box
        width={200}
        marginBottom="2"
        marginLeft={{ base: 'auto', lg: 'initial' }}
      >
        <Select
          aria-label="Set order"
          components={{ SingleValue }}
          isSearchable={false}
          onChange={onSortByChange}
          options={sortingOptions}
          value={sortByValue}
        />
      </Box>
    </Flex>
  );
};

DesktopFiltersBar.propTypes = propTypes;

export default DesktopFiltersBar;
